import { Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openRequestModal } from '../../actions/modals';
import TableQuizzes from '../../components/Quiz/CreateQuiz/TableQuizzes';

export default function CreateQuizPage() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const handleOpenAddNewsModal = () => {
        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    header: t('quiz.createQuiz'),
                    modaltype: 'CreateQuiz',
                },
            })
        );
    };
    return (
        <>
            <Typography className="container-header" variant="h2">
                Quiz
            </Typography>
            <Paper elevation={0}>
                <Button
                    variant="contained"
                    onClick={handleOpenAddNewsModal}
                    style={{
                        width: '150px',
                        padding: '5px',
                        borderRadius: '4px',
                        margin: '15px',
                    }}
                >
                    {t('quiz.createQuiz')}
                </Button>
                <TableQuizzes />
            </Paper>
        </>
    );
}
